import Client from './client';

export default class OrganizationRestrictionStatusNotes extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, options = {}) {
    return this.makeRequest(`${this.host}/restriction/${organization}/status/notes`, options);
  }

  post(organization, options = {}) {
    return this.makeRequest(`${this.host}/restriction/${organization}/status/notes`, {
      ...options,
       method: 'POST',
    });
  }

  putById(organization, id, options = {}) {
    return this.makeRequest(`${this.host}/restriction/${organization}/status/notes/${id}`, {
      ...options,
       method: 'PUT',
    });
  }

}
